import CryptoJS from "crypto-js";
import { ENCRYPTION_KEY } from "@/lib";

export class Encryption {
  static encrypt(value: any): string {
    return CryptoJS.AES.encrypt(
      JSON.stringify(value),
      ENCRYPTION_KEY
    ).toString();
  }

  static decrypt(value: string): string {
    return CryptoJS.AES.decrypt(value, ENCRYPTION_KEY).toString(
      CryptoJS.enc.Utf8
    );
  }

  static encodeBase64(value: string): string {
    return btoa(unescape(encodeURIComponent(value)));
  }

  static decodeBase64(value: string): string {
    return decodeURIComponent(escape(atob(value)));
  }
}
